<div class="sidebar-drawer">
  <div class="dealer-review-form" *ngIf="!isShowThankyouPage">
    <div class="drawer-header">
      <h5 class="drawer-title">Write a review</h5>
      <button type="button" (click)="Close()" class="btn-close"></button>
    </div>
    <div class="drawer-body">
      <form [formGroup]="customerRatingForm">
        <div class="prod-content">
          <div class="card">
            <div class="card-body">
              <img [src]="data.mainImage" class="img-fluid" alt="{{ data.model }}" loading="lazy">
            </div>
          </div>
          <h4>{{ data.model }} </h4>
        </div>
        <div class="ratings">
          <h5 class="drawer-title">Overall Rating<span>*</span></h5>
          <div class="rating">
            <ngx-stars [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="overall"
              [size]="5" (ratingOutput)="onRatingSet($event,'overall')"></ngx-stars>
          </div>
        </div>
        <div class="ratings">
          <h5 class="drawer-title">Rate features</h5>
          <div class="feature">
            <div class="drawer-sub-title">Performance</div>
            <div class="rating">
              <ngx-stars [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="performance"
                [size]="5" (ratingOutput)="onRatingSet($event,'performance')"></ngx-stars>
            </div>
          </div>
          <div class="feature">
            <div class="drawer-sub-title">Safety</div>
            <div class="rating">
              <ngx-stars [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="safety"
                [size]="5" (ratingOutput)="onRatingSet($event,'safety')"></ngx-stars>
            </div>
            <div class="feature">
              <div class="drawer-sub-title">Comfort</div>
              <div class="rating">
                <ngx-stars [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="comfort"
                  [size]="5" (ratingOutput)="onRatingSet($event,'comfort')"></ngx-stars>
              </div>
              <div class="feature">
                <div class="drawer-sub-title">Design and Style</div>
                <div class="rating">
                  <ngx-stars [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="design"
                    [size]="5" (ratingOutput)="onRatingSet($event,'design')"></ngx-stars>
                </div>
              </div>
              <div class="title-review">
                <h5 class="drawer-title">Title your review <span>*</span></h5>
                <input type="text" class="form-control" name="title-review" id="title-review"
                  formControlName="titleAndReview"  (keydown)="notAllowSpace($event)" >
              </div>
              <div class="comment-area">
                <h5 class="drawer-title">Write a review</h5>
                <textarea name="comment" id="comment" cols="10" rows="5" class="form-control"
                (keydown)="notAllowSpace($event)"
                  placeholder="Tell us how we can improve" formControlName="writeReview"  maxlength="300"></textarea>
              </div>
              <div class="upload-item">
                <h5 class="drawer-title">Upload photos</h5>
                <p class="drawer-sub-title">Customers find images and videos more helpful than text alone</p>
                <div class="upload-file" *ngIf="!imageURL">
                  <input type="file"  name="myfile" accept="image/jpeg,image/jpg,image/png,image/webp" (change)="onSelectImagefile($event)">
                  <div class="upload-img">
                    <img [src]='environment1 + "assets/images/upload-plus.png"' class="img-fluid" alt="upload" loading="lazy">
                  </div>
                </div>
                <div class="preview-img" *ngIf="imageURL">
                  <img [src]="imageURL" class="img-fluid" alt="customer_image" loading="lazy">
                  <div class="overlay">
                    <a  class="cancel-img" (click)="removeImage()">
                      <img [src]="environment1 + 'images/new-images/circle.svg'" alt="circle" loading="lazy">

                    </a>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="cta-action d-grid">
          <button *ngIf="!data.ratingPresent" type="button" class="btn btn-primary btn-grad-primary btn-comment btn-disabled"
            (click)="writeReview()">Submit</button>
            <button *ngIf="data.ratingPresent" type="button" class="btn btn-primary btn-grad-primary btn-comment btn-disabled"
            (click)="updateProductRating()">Update</button>
        </div>
      </form>
    </div>
  </div>
  <div class="review-thank" *ngIf="isShowThankyouPage">
    <div class="content-area">
      <div class="img">
        <img [src]="environment1 + 'images/new-images/messageBig.svg'" alt="messageBig" loading="lazy">
      </div>
      <div class="content">
        <h4>Review Submitted- Thank you!</h4>
        <p>Your feedback is important to us and will help us improve our product/service.</p>
        <div class="action-cta">
          <button type="button" class="btn  btn-primary btn-grad-primary close-btn" (click)="Close()">Close</button>
        </div>
      </div>
    </div>

  </div>
</div>
